export const WELCOME = '/welcome'

const welcomeRoutes = [WELCOME]

export default welcomeRoutes
